import { BaseApi } from './BaseApi';
import { CancelToken } from 'axios';

export default class Categories extends BaseApi {
  public async getByStoreRouteAsync(cancelToken?: CancelToken) {
    return await this.getListAsync<ICategory>('categories', null, cancelToken);
  }
}
